import { Menu, MenuProps, usePermissions, useTranslate } from 'react-admin'
import { Box, IconButton, Collapse } from '@mui/material'
import { WorkspacePremium } from "@mui/icons-material"
import { ArrowBack, ExpandLess, ExpandMore, Preview } from '@mui/icons-material'
import { CustomMenuItemLink } from './CustomMenuItemLink'
import { useEffect, useState } from 'react'
import { Permissions } from '../authentication/Permissions'
import UpgradeDialog from '../authorization/UpgradeDialog'

const CustomMenu = ({...props}: MenuProps) => {

  const translate = useTranslate()
  const fffBaseUrl = process.env.REACT_APP_FREE_FIBU_BASE_URL ? process.env.REACT_APP_FREE_FIBU_BASE_URL : 'http://localhost:10101/fff'
  const [open, setOpen] = useState<boolean>(false)
  const [openUpgradeDialog, setOpenUpgradeDialog] = useState<boolean>(false)
  const { isLoading, permissions } = usePermissions<Permissions>()

  useEffect(() => {
    (window.location.href.includes("drafts")
    || window.location.href.includes("invoiceReminders")
    || window.location.href.includes("reverseInvoices"))
    && setOpen(true)
  }, [window.location.href])
  
  if(isLoading) return null

  return (
    <Menu>
      <Menu.DashboardItem />
      <Box display={"flex"} justifyContent={"space-between"}>
        <Menu.ResourceItem name='invoices' />
        <IconButton onClick={() => setOpen(!open)} >{open ? <ExpandLess/> : <ExpandMore />}</IconButton> 
      </Box>
      <Collapse in={open} timeout={"auto"} unmountOnExit sx={{pl: 1}}>
        <Menu.ResourceItem name='drafts' />
        <Menu.ResourceItem name='invoiceReminders' />
        <Menu.ResourceItem name='reverseInvoices' />
      </Collapse>
      <Menu.ResourceItem name='customers' />
      <Menu.ResourceItem name='products' />
      <Menu.ResourceItem name='numberRanges' />
      <Menu.Item to={"xmlInvoices"} primaryText="X-Rechnung Vorschau" leftIcon={<Preview />} />
      <CustomMenuItemLink 
        onClick={() => permissions.fffUser ? undefined : setOpenUpgradeDialog(true)} 
        sx={{mt:2}} 
        to={""} 
        href={permissions.fffUser ? `${fffBaseUrl}/status` : undefined} 
        primaryText={
          <>
            {translate("resources.invoices.actions.back")}
            {!permissions.fffUser && <WorkspacePremium sx={{ml:0.5}} fontSize='small' color='action' />}
            
          </>
        } 
        leftIcon={<ArrowBack fontSize='small' />}
      />

      <UpgradeDialog 
        open={openUpgradeDialog}
        setOpen={setOpenUpgradeDialog}
        title={translate("resources.authorization.upgradeDialog.title")}
        content={translate("resources.authorization.upgradeDialog.description")}
      />
    </Menu>
  )
}

export default CustomMenu